export const SET_STORE_LOGOS_START = 'SET_STORE_LOGOS_START';
export const SET_STORE_LOGOS_SUCCESS = 'SET_STORE_LOGOS_SUCCESS';
export const SET_STORE_LOGOS_FAILED = 'SET_STORE_LOGOS_FAILED';
export const GET_STORE_LOGOS_START = 'GET_STORE_LOGOS_START';
export const GET_STORE_LOGOS_SUCCESS = 'GET_STORE_LOGOS_SUCCESS';
export const GET_STORE_LOGOS_FAILED = 'GET_STORE_LOGOS_FAILED';
export const GET_CONFIGS_LOGOS_START = 'GET_CONFIGS_LOGOS_START';
export const GET_CONFIGS_LOGOS_SUCCESS = 'GET_CONFIGS_LOGOS_SUCCESS';
export const GET_CONFIGS_LOGOS_FAILED = 'GET_CONFIGS_LOGOS_FAILED';
export const UPLOAD_STORE_LOGOS_START = 'UPLOAD_STORE_LOGOS_START';
export const UPLOAD_STORE_LOGOS_SUCCESS = 'UPLOAD_STORE_LOGOS_SUCCESS';
export const UPLOAD_STORE_LOGOS_FAILED = 'UPLOAD_STORE_LOGOS_FAILED';
export const UPLOAD_STORE_LOGOS_TYPE_FAILED = 'UPLOAD_STORE_LOGOS_TYPE_FAILED';
export const SET_CONFIG_LOGOS_START = 'SET_CONFIG_LOGOS_START';
export const SET_CONFIG_LOGOS_SUCCESS = 'SET_CONFIG_LOGOS_SUCCESS';
export const SET_CONFIG_LOGOS_FAILED = 'SET_CONFIG_LOGOS_FAILED';
export const UPDATE_ALL_LOGOS_START = 'UPDATE_ALL_LOGOS_START';
export const UPDATE_ALL_LOGOS_SUCCESS = 'UPDATE_ALL_LOGOS_SUCCESS';
export const UPDATE_ALL_LOGOS_FAILED = 'UPDATE_ALL_LOGOS_FAILED';
export const UPLOAD_FILE_TYPE_UNSUPPORTED = 'UPLOAD_FILE_TYPE_UNSUPPORTED';
export const UPLOAD_FILE_SIZE_LIMIT = 'UPLOAD_FILE_SIZE_LIMIT';
export const UPLOAD_IMAGE_RESOLUTION_LIMIT = 'UPLOAD_IMAGE_RESOLUTION_LIMIT';
export const UPLOAD_FILE_NAME_UNSUPPORTED_SYMBOLS = 'UPLOAD_FILE_NAME_UNSUPPORTED_SYMBOLS';


export const setStoreLogoStart = () => ({
  type: SET_STORE_LOGOS_START,
});

export const setStoreLogoSuccess = (data) => ({
  type: SET_STORE_LOGOS_SUCCESS,
  data
});

export const setStoreLogoFailed = (error) => ({
  type: SET_STORE_LOGOS_FAILED,
  error
});

export const getStoreLogosStart = () => ({
  type: GET_STORE_LOGOS_START
});

export const getStoreLogosSuccess = (data) => ({
  type: GET_STORE_LOGOS_SUCCESS,
  data
});

export const getStoreLogosFailed = (error) => ({
  type: GET_STORE_LOGOS_FAILED,
  error
});

export const getConfigsLogosStart = () => ({
  type: GET_CONFIGS_LOGOS_START
});

export const getConfigsLogosSuccess = (data, apiUrl) => ({
  type: GET_CONFIGS_LOGOS_SUCCESS,
  data,
  apiUrl
});

export const getConfigsLogosFaild = (error) => ({
  type: GET_CONFIGS_LOGOS_FAILED,
  error
});

export const uploadStoreLogoStart = () => ({
  type: UPLOAD_STORE_LOGOS_START
});

export const uploadStoreLogoSuccess = (data, key) => ({
  type: UPLOAD_STORE_LOGOS_SUCCESS,
  data,
  key
});

export const uploadStoreLogoFailed = (error) => ({
  type: UPLOAD_STORE_LOGOS_FAILED,
  error
});

export const uploadStoreLogoBadType = () => ({
  type: UPLOAD_STORE_LOGOS_TYPE_FAILED,
});

export const setConfigLogosStart = () => ({
  type: SET_CONFIG_LOGOS_START,
});

export const setConfigLogosSuccess = (data) => ({
  type: SET_CONFIG_LOGOS_SUCCESS,
  data
});

export const setConfigLogosFailed = (error) => ({
  type: SET_CONFIG_LOGOS_FAILED,
  error
});

export const updateAllLogosStart = () => ({
  type: UPDATE_ALL_LOGOS_START,
});

export const updateAllLogosSuccess = () => ({
  type: UPDATE_ALL_LOGOS_SUCCESS
});

export const updateAllLogosFailed = () => ({
  type: UPDATE_ALL_LOGOS_FAILED,
});

export const uploadFileTypeUnsupported = () => ({
  type: UPLOAD_FILE_TYPE_UNSUPPORTED
});

export const uploadFileSizeLimit = (sizeLimit) => ({
  type: UPLOAD_FILE_SIZE_LIMIT,
  sizeLimit
});

export const uploadImageResolutionLimit = (resolutionLimit) => ({
  type: UPLOAD_IMAGE_RESOLUTION_LIMIT,
  resolutionLimit
});

export const uploadFileNameUnsupportedSymbols = (fileName) => ({
  type: UPLOAD_FILE_NAME_UNSUPPORTED_SYMBOLS,
  fileName
});
